import { useEffect, useRef } from "react";

export function base64Encoding(value:string|null) {
    if(value) {
        return btoa(unescape(encodeURIComponent(value)));
    }
    else{ return '' }
};

export function base64Decoding(value:string|null) {
    if(value) {
        return decodeURIComponent(escape(atob(value)));
    }
    else {
        return ''
    }
};

export function clearSessionStorage(){
    sessionStorage.clear();
}

export function getCurrentTimestamp(date?:Date){
    if(date) {
        return Math.floor(date.getTime() / 1000);
    }
    return Math.floor(new Date().getTime() / 1000);
}

export function getDiffDate(beforeDate:number, afterDate:number) {
    const day = afterDate - beforeDate;
    if (day > 0) {
        return Math.floor(day / (1 * 3600 * 24)) + "일";
    }
    else {
        return "0일";
    }
}

export function getTimestampToDate(timestamp, div=".", dateOnlyYn=false, timeOnly=false) {
    if(timestamp === 0) {
        if(dateOnlyYn) {
            return "0000.00.00";
        } else {
            return "0000.00.00" + div + "00:00:00"
        }
    }
    const dateObject = new Date(timestamp * 1000);
    const year = dateObject.getFullYear();
    const month = ("00" + (dateObject.getMonth() + 1)).slice(-2);
    const day = ("00" + dateObject.getDate()).slice(-2);
    const hours = ("00" + dateObject.getHours()).slice(-2);
    const minutes = ("00" + dateObject.getMinutes()).slice(-2);
    const seconds = ("00" + dateObject.getSeconds()).slice(-2);

    if(dateOnlyYn) {
        return year + "." + month + "." + day;
    }
    if(timeOnly) {
        return hours + ":" + minutes;
    }
    return year + "." + month + "." + day + div + hours + ":" + minutes + ":" + seconds;
}

export function timestampToDate(timestamp?:number, default_format="0000.00.00"){
    let to_date;
    if(!timestamp || timestamp === 0){
        return default_format;
    }

    const date_object = new Date(timestamp * 1000);
    const year = date_object.getFullYear();
    const month = ("00" + (date_object.getMonth() + 1)).slice(-2);
    const day = ("00" + (date_object.getDate())).slice(-2);
    const hours = ("00" + (date_object.getHours())).slice(-2);
    const minutes = ("00" + (date_object.getMinutes())).slice(-2);
    const seconds = ("00" + (date_object.getSeconds())).slice(-2);

    if(default_format === "0000.00.00"){
        to_date = year + "." + month + "." + day;
    }
    else if(default_format === "00/00/0000"){
        to_date = month + "/" + day + "/" + year;
    }
    else if(default_format === "0000-00-00"){
        to_date = year + "-" + month + "-" + day;
    }
    else if(default_format === "00-00-00"){
        to_date = year.toString().substr(-2) + "-" + month + "-" + day;
    }
    else if(default_format === "00.00.00"){
        to_date = year.toString().substr(-2) + "." + month + "." + day;
    }
    else if(default_format === "0000.00.00 00:00"){
        to_date = year + "." + month + "." + day + " " + hours + ":" + minutes;
    }
    else if(default_format === "0000.00.00 00:00:00"){
        to_date = year + "." + month + "." + day + " " + hours + ":" + minutes + ":" + seconds;
    }
    else if(default_format === "0000년 00월") {
        to_date = year + "년 " + month + "월";
    }
    else if(default_format === "00월 00일") {
        to_date = month + "월 " + day + "일";
    }
    else if(default_format === "0000년 00월 00일 00:00") {
        to_date = year + "년 " + month + "월 " + day + "일 " + hours + ":" + minutes;
    }
    else if(default_format === "00000000") {
        to_date = "" + year + month + day;
    }
    else if(default_format === "00일") {
        to_date = day + "일";
    }
    else if(default_format === "00월") {
        to_date = month + "월";
    }
    else if(default_format === "00시간 00분") {
        to_date = hours + "시간 " + minutes + "분" ;
    }
    else if(default_format === "month 00,0000") {
        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        to_date = monthNames[date_object.getMonth()] + " " + day + "," + year;
    }
    else{
        return default_format;
    }

    return to_date;
}

export function secondsToTime(seconds:number, default_format="hhmmss") {
    let text:string = '';
    if(seconds === 0) {
        if(default_format === "hh:mm") {
            text = "00:00";
        }
        else {
            text = "미사용";
        }
    }

    const hour = Math.floor(seconds/3600);
    const min = Math.floor((seconds%3600)/60);
    const sec = Math.floor(seconds%60);
    if (default_format === "hhmmss") {
        if ( hour === 0 ){
            text = min + " 분 " + sec + " 초";
        }
        else {
            text =  hour + " 시간 " + min + " 분 " + sec + " 초";
        }
    }
    else if(default_format === "hhmm") {
        if ( hour === 0 ){
            text = min + " 분";
        }
        else {
            text = hour + " 시간 " + min + " 분";
        }
    }
    else if(default_format === "hh:mm") {
        if ( hour === 0 ){
            text = "00 : " +  zeroFill(min,2);
        }
        else {
            text = hour + " : " + min;
        }
    }
    return text

}

export function zeroFill(number:number, size=2){
    if(number > (Math.pow(10, size) - 1)){
        return number;
    }

    var result = "";
    for(var i=0; i<size; i++){
        result += "0";
    }

    result += number;

    return result.slice(-size);
}

export function convertNumberToWeekday(number:number) {
    if (number >= 7 || number < 0) {
        return ;
    }
    const weekday_list = ["일", "월", "화", "수", "목", "금", "토"];
    return weekday_list[number];
}

export function getUrlParameter(param:string){
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
}

export function maskPhoneNumber(phone?:string) {
    if (!phone) {
        return;
    }
    if (phone.length !== 11) {
        return;
    }
    const phone_mask = (phone.substring(0,3) + '-' + phone[3] + '***-' + phone[7] + '***');
    return phone_mask;
}

export function checkFormatAllow(value:string, allows:string[]){
    let regex_target:RegExp;
    let result = false;
    for(const allow of allows){
        if(allow === "korean"){
            regex_target = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]+$/;
        }
        else if(allow === "english"){
            regex_target = /^[a-zA-Z]*$/;
        }
        else if(allow === "number"){
            regex_target = /^[0-9]+$/;
        }
        else if(allow === "password"){
            regex_target = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{9,30}$/;
        }
        else if(allow === "email"){
            regex_target = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        }
        else if(allow === "ip_address"){
            regex_target = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        }
        else if(allow === "mac_address"){
            regex_target = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        }
        else{
            return false;
        }

        if(regex_target.test(value)){
            result = true;
        }
        else{
            result = false;
        }
    }

    return result;
}

export function numberToPrice(value?:number){
    if(value) {
        return new Intl.NumberFormat().format(value);
    }
    else {
        return 0;
    }
}

export function inquiryMailSend() {
    window.location.href = "mailto:fornax_support@gloovir.com";
}

export function getUUID(){
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
}

export function jsonReplacer(key, value) {
    if(value === "") return undefined;
    if(value instanceof Object && Object.keys(value).length === 0) return undefined;

    return value;
}

export function cutStringLength(value, length, paddRight=true) {
    if (value.length > length) {
        return value.substr(0, length) + '...';
    }

    if(paddRight === false){
        let newValue = "";

        for(var i = 0; i < length + 3 - value.length; i++){
            newValue += " ";
        }
        return newValue + value;
    } else {
        let newValue = value;

        for(var i = 0; i < length + 3 - value.length; i++){
            newValue += " ";
        }
        return newValue;
    }
}


export function percentValue(data:number, total:number) {
    if(total === 0) {
        return 0;
    }
    return Math.floor(data/total * 100)
}

export function parseKeyValue(str, eq='=', div=',') {
    interface KeyValue {
        key: string;
        value: string;
    }
    if(!str) {
        return [];
    }
    let result: KeyValue[] = [];
    let splits = str.split(div);
    if(splits.length < 1) {
        return [];
    }
    for(let split of splits) {
        let keyValue = split.split(eq);
        if (keyValue.length <= 1){
            continue;
        }
        result = [...result, { key: keyValue[0], value: keyValue[1] }]
    }
    return result;
}

export function parseDivValue(str, div=',') {
    if(!str) {
        return [];
    }
    return str.split(div);
}


export function checkUpperString(str) {
    let reg = /^[a-z]{1}[a-z0-9_-]{3,19}$/;
    return reg.test(str);
}

export function convertUnit(value, suffix=0) {
    if(value > 1024 * 1024 * 2) {
        return Number((value / 1024 / 1024).toFixed(suffix));
    } else if(value > 1024 * 2) {
        return Number((value / 1024).toFixed(suffix));
    }
    return value
}

export function getUnit(value, unit='MB') {
    if(value > 1024 * 1024 * 2) {
        if(unit === 'MB') {
            return 'TB';
        } else if(unit === 'GB') {
            return 'PB';
        }
    } else if(value > 1024 * 2) {
        if(unit === 'MB') {
            return 'GB';
        } else if(unit === 'GB') {
            return 'TB';
        }
    }
    return unit;
}



export function parseLocaleDatetime(dt?:string, tzYn=false) {
    // yyyy-mm-dd HH:MM:SS%z -> yyyy. mm. dd. HH:MM:SS
    // timezone -> locale timezone
    let date;
    if(dt === null) {
        return "";
    }
    if(dt){
        date = new Date(dt);
    } else {
        date = new Date();
    }
    const datetime = date.getFullYear() + '. ' + (date.getMonth() + 1).toString().padStart(2, '0') + '. ' + date.getDate().toString().padStart(2, '0') + ' ' + date.getHours().toString().padStart(2, '0') + ':' + date.getMinutes().toString().padStart(2, '0') + ':' + date.getSeconds().toString().padStart(2, '0');

    if(tzYn === true) {
        let offset = date.getTimezoneOffset();
        let oper = '-';
        if(offset < 0) {
            oper = '+';
            offset *= -1;
        }
        offset = parseInt((offset / 60).toFixed());

        return datetime + " GMT" + oper + offset;
    } else {
        return datetime;
    }
}

//TODO: sortByName, soertByDescYn, categoryType, categoryCode 는 정의되지 않음. 어떠한 값인지?
export function generateQueryParam(pageSize, pageIndex, sortByName, sortByDescYn, categoryType, categoryCode, search) {
    const queryParam = {};

    queryParam['page'] = pageIndex + 1;
    queryParam['size'] = pageSize;

    if(search && search.length > 0) {
        queryParam['search'] = search;
    }
    if(sortByName) {

        if (sortByDescYn === true) {
            queryParam['order_by'] = '-' + sortByName
        } else {
            queryParam['order_by'] = sortByName
        }
    }

    return queryParam
}

export function deepCopyObject(inObject: any) {
    let value: string;
    let outObject: any;
    var key: string;
    if (typeof inObject !== "object" || inObject === null) {
      return inObject;
    }
    outObject = Array.isArray(inObject) ? [] : {};
    for (key in inObject) {
      value = inObject[key];
      outObject[key] =
        typeof value === "object" && value !== null
          ? deepCopyObject(value)
          : value;
    }
    return outObject;
}

export function numberOfCommas(num: number) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



export const sleep = ms => new Promise(r => setTimeout(r, ms));


export function useInterval(callback: () => void, delay) {
    const savedCallback = useRef(callback);

    // Remember the latest function.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
    }, [delay]);
}